import { action, observable } from 'mobx';
import { FieldState, FormState } from 'formstate';
import { ActionType } from '../../../core/types/ActionType';
import { SetupStoreNoProfile } from '../../commons/store/SetupStoreNoProfile';
import newPortalService from '../services/NewPortalService';
import { getFormValue, showToastNotification } from 'welltrax-ui-components';
import { intl } from '../../../core/utils/Intl';
import { manageAppOverlay } from '../../commons/components/appOverlay/ManageAppOverlay';

export class NewPortalStore extends SetupStoreNoProfile {
  @observable
  formState: ActionType;

  @observable
  error: any;

  constructor() {
    super(newPortalService);
    this.formState = 'CREATE';
    this.createForm();
  }

  @action setLoading(value: boolean) {
    this.isLoading = value;
  }

  @action createForm = () => {
    this.form = new FormState<any>({
      databaseOrgName: new FieldState(''),
      supportUsername: new FieldState(''),
      supportPassword: new FieldState(''),
      commodityList: new FieldState(['CRUDE']),
      financeModule: new FieldState('NO'),
      complianceModule: new FieldState('NO'),
      crudeCommodity: new FieldState('YES'),
      eld: new FieldState('NONE'),
      geotabUsername: new FieldState(''),
      geotabPassword: new FieldState(''),
      geotabDatabaseName: new FieldState(''),
      samsaraToken: new FieldState(''),
      vapiUsername: new FieldState(''),
      vapiPassword: new FieldState(''),
      ticketApiUsername: new FieldState(''),
      ticketApiPassword: new FieldState('')
    });
  };

  @action
  setFormState = (state: ActionType) => {
    this.formState = state;
    if (state === 'CREATE') {
      this.createForm();
    }
  };

  @action
  setError = (error: any) => {
    this.error = error;
  };

  setOverlayProperties = (isOpen: boolean, text?: string) => {
    manageAppOverlay(
      isOpen
        ? {
            isOpen,
            text: text || ''
          }
        : undefined
    );
  };

  handleSave = async (noGetElements: boolean = false, onSuccessful?: any, onError?: any) => {
    const validator = await this.form.validate();
    if (validator?.hasError) {
      showToastNotification({
        message: intl('app.formError'),
        type: 'danger'
      });
      return;
    }

    this.handleCreateOrEdit(noGetElements, onSuccessful, onError);
  };

  handleCreateOrEdit = async (noGetElements: boolean = false, onSuccessful?: any, onError?: any) => {
    this.setLoading(true);
    this.setOverlayProperties(true, intl(`newPortal.newPortalCreateStatus'}`, 'Portal Creation Running...'));
    this.serviceContainer
      .createNewPortal(this.createElementToSave())
      .then(async (response: any) => {
        if (response?.data) {
          const interval = setInterval(() => {
            this.serviceContainer
              .checkPortalCreationStatus(response?.data?.executionName)
              .then((creationResponse: any) => {
                if (creationResponse?.data?.status !== 'RUNNING') {
                  this.setLoading(false);
                  this.setOverlayProperties(false);
                  if (creationResponse?.data?.status === 'FAILED') {
                    this.showFormErrorMessage(creationResponse?.data?.status);
                  } else if (creationResponse?.data?.status === 'SUCCEEDED') {
                    this.showSuccessMessage(creationResponse?.data?.status);
                    this.setFormState('CREATE');
                  }
                  clearInterval(interval);
                }
              })
              .catch((creationResponse: any) => {
                this.setLoading(false);
                this.setOverlayProperties(false);
                this.showFormErrorMessage(creationResponse?.data?.message);
              });
          }, 3000);

          //this.showSuccessMessage();
          //if (onSuccessful) {
          //  await onSuccessful(response.data);
          //}
          return () => clearInterval(interval);
        }
      })
      .finally(() => {});
  };

  createElementToSave = () => {
    const {
      databaseOrgName,
      supportUsername,
      supportPassword,
      commodityList,
      financeModule,
      complianceModule,
      crudeCommodity,
      eld,
      samsaraToken,
      geotabUsername,
      geotabPassword,
      geotabDatabaseName,
      vapiUsername,
      vapiPassword,
      ticketApiUsername,
      ticketApiPassword
    } = getFormValue(this.form);
    return {
      supportUsername,
      supportPassword,
      commodityList,
      dbOrgName: databaseOrgName,
      financeModuleActive: financeModule === 'NO' ? false : true,
      complianceModuleActive: complianceModule === 'NO' ? false : true,
      crudeCommodityActive: crudeCommodity === 'NO' ? false : true,
      ...(eld === 'GEOTAB'
        ? {
            geotabConfig: {
              geotabUsername,
              geotabPassword,
              geotabDatabaseName
            }
          }
        : null),
      ...(eld === 'SAMSARA'
        ? {
            samsaraConfig: {
              samsaraToken
            }
          }
        : null),
      vapiUsername,
      vapiPassword,
      ticketApiUsername,
      ticketApiPassword
    };
  };
}
